angular.
module("dx.webapp.examParts").
directive("dxExamPartsSelector", function examPartsSelectorDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			exam: "=",
			availableOptions: "<",
			selection: "=",
			isDisabled: "=",
		},
		templateUrl: "tmpl/exam-parts/exam-parts-selector-directive.html",
		replace: true,
		controller: "DxExamPartsController",
		controllerAs: "vm",
		bindToController: true,
	};
});
